import React, { useState } from 'react';
import parse from "html-react-parser";

// Function to remove width and height attributes from SVG
function removeWidthAndHeightAttributes(svgString) {
    return svgString.replace(/width="[^"]*"/, '').replace(/height="[^"]*"/, '');
}

const PresupuestoItemCard2 = ({ item, handleViewItem }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleThumbnailClick = () => {
        setIsModalOpen(true); // Open modal when thumbnail is clicked
    };

    const handleCloseModal = () => {
        setIsModalOpen(false); // Close modal
    };

    const svgContent = item?.keyring_model?.svg_2d ? removeWidthAndHeightAttributes(item?.keyring_model?.svg_2d) : '';

    return (
        <>
            {/* Main Card */}
            <div className="bg-base-300 rounded-lg shadow-md p-4 flex flex-row space-x-4 items-center justify-between transition duration-150 ease-in-out">

                {/* Left Side - Text Information */}
                <div className="flex flex-col space-y-2">
                    <div className="text-gray-700 dark:text-gray-300 font-semibold">
                        Item #{item.id}
                    </div>
                    <div className="text-gray-700 dark:text-gray-300">
                        Unidades: {item.unidades}
                    </div>
                    <div className="text-gray-700 dark:text-gray-300">
                        Precio por Unidad: {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(item.precio_por_unidad)}
                    </div>
                    <div className="text-gray-700 dark:text-gray-300">
                        Descuento: {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(item.descuento_valor_fijo)}
                    </div>
                    <div className="text-gray-700 dark:text-gray-300 font-bold">
                        Total: {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(item.precio_total)}
                    </div>
                </div>

                {/* Right Side - Thumbnail and Button */}
                <div className="flex flex-col items-center space-y-3">
                    {/* Thumbnail */}
                    <div
                        className="flex items-center justify-center w-24 h-24 bg-gray-100 dark:bg-gray-700 rounded-md cursor-pointer overflow-hidden"
                        onClick={handleThumbnailClick} // Trigger modal on click
                    >
                        <div className="w-full h-full flex items-center justify-center">
                            {/* Inner div to ensure SVG fits the container with correct aspect ratio */}
                            <div className="w-full h-full max-w-full max-h-full flex items-center justify-center p-2">
                                {svgContent && parse(removeWidthAndHeightAttributes(svgContent))}
                            </div>
                        </div>
                        {/*{svgContent && parse(removeWidthAndHeightAttributes(svgContent))}*/}
                    </div>

                    {/* Action Button */}
                    <button
                        className="bg-blue-500 text-white py-1 px-3 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 dark:bg-blue-600 dark:hover:bg-blue-700"
                        onClick={() => handleViewItem(item.keyring_model?.id)}
                    >
                        Ver 3D
                    </button>
                </div>
            </div>

            {/* Modal for SVG Preview */}
            {isModalOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black bg-opacity-50">
                    <div className="glassCard rounded-lg shadow-lg p-6 max-w-lg w-full">
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-lg font-semibold text-gray-700 dark:text-gray-300">Vista Previa</h2>
                            <button
                                onClick={handleCloseModal}
                                className="text-gray-500 hover:text-gray-700 dark:hover:text-gray-400"
                            >
                                ✕
                            </button>
                        </div>

                        <div className="flex items-center justify-center">
                            <div className="w-full h-full max-w-full max-h-full flex items-center justify-center overflow-hidden">
                                {/* Display SVG in full size */}
                                {item?.keyring_model?.svg_2d && parse(removeWidthAndHeightAttributes(item?.keyring_model?.svg_2d))}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default PresupuestoItemCard2;
